import { ReactElement, useEffect, useRef, useState } from "react";
import "./Floater.css";

const Floater = ({
  children,
  className,
}: {
  children: ReactElement;
  className?: string;
}) => {
  const floatRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState<number | undefined>();

  useEffect(() => {
    const getMaxHeight = () => {
      const windowHeight = window.innerHeight;
      const top = floatRef.current?.getBoundingClientRect().top || 0;
      const padding = 16;
      const maxHeight = windowHeight - (top + padding);
      setMaxHeight(maxHeight);
    };
    getMaxHeight();
    window.addEventListener("resize", getMaxHeight);

    return () => {
      window.removeEventListener("resize", getMaxHeight);
    };
  }, []);

  return (
    <div
      ref={floatRef}
      style={{ maxHeight: maxHeight ? maxHeight : `` }}
      className={`floater ${className || ``}`}
    >
      {children}
    </div>
  );
};

export default Floater;
